<template>
	<div class="row">
		<div class="col-12 my-2">
			<stats-graph
				:graph_data="venue_data.bar_graph_data"
			></stats-graph>
		</div>
		<div class="col-12 my-2">
			<stats-scores
				:venue="venue"
				:venue_data="venue_data"
				radial_subtitle_1="Last Audit"
				:radial_subtitle_2="'Average score for \'' + venue.name + '\''"
			></stats-scores>
		</div>
	</div>
</template>

<script>
	import StatsGraphComponent from './StatsGraphComponent.vue';
	import StatsAndScoresComponent from './StatsAndScoresComponent.vue'

	export default {
		components:{
			'stats-graph': StatsGraphComponent,
			'stats-scores': StatsAndScoresComponent
		},

		props:[
			'venue', 'venue_data'
		],

		data(){
			return {

			}
		},

		mounted() {

		},

		methods: {

		},
	}
</script>
